import { get } from 'lodash';
import React from 'react';
import { Form, OriCheckbox } from 'src/components/Antd';
import { OriNumberInput as NumberInput } from 'src/components/Antd/NumberInput/NumberInput';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/SectionWrapper';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

const Item = Form.Item;

const PasswordFormat = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { setHasModified, form, disableEdit } = props;
  const onChange = () => {
    // onChange: () => {
    if (setHasModified) {
      setHasModified(true);
    }
    form.validateFields([['passwordFormat', 'maxLength']]);
    // },
  };
  //   const v = () => {
  //     form.validateFields([['passwordFormat', 'maxLength']]);
  //   };
  //   const {
  //     //  enableVisible,
  //     //  enableMustContainNumbers,
  //     minNumOfNumbers,
  //     //enableMustContainLetters,
  //     minNumOfLetters,
  //     // enableMustContainLowerCases,
  //     minNumOfLowerCases,
  //     // enableMustContainUpperCases,
  //     minNumOfUpperCases,
  //     //   enableMustContainSpecialChars,
  //     minNumOfSpecialChars,
  //     //   enableMinLength,
  //     minLength,
  //     enableMaxLength,
  //     maxLength,
  //   } = data || {};
  return (
    <SectionWrapper
      title={getI18n('salesChannelRegistration.index.customerPasswordFormat')}
      containerClassName={css.containerClassName}>
      <Item name={['passwordFormat', 'enableVisible']} valuePropName='checked'>
        <OriCheckbox
          onChange={onChange}
          className={css.checkbox}
          disabled={disableEdit}>
          {getI18n(
            'salesChannelRegistration.index.allowuserstomakepasswordvisible',
          )}
        </OriCheckbox>
      </Item>
      <React.Fragment>
        <Item
          name={['passwordFormat', 'enableMustContainNumbers']}
          valuePropName='checked'>
          <OriCheckbox
            onChange={onChange}
            className={css.checkbox}
            disabled={disableEdit}>
            {getI18n('salesChannelRegistration.index.mustcontainsnumbers')}
          </OriCheckbox>
        </Item>
        <ShouldUpdateItem name='passwordFormat.enableMustContainNumbers'>
          {({ getFieldValue }: any) => {
            const enable = getFieldValue([
              'passwordFormat',
              'enableMustContainNumbers',
            ]);
            return enable ? (
              <_NumberInput
                // max={10}
                disabled={disableEdit}
                onChange={onChange}
                formProps={{
                  name: ['passwordFormat', 'minNumOfNumbers'],
                  rules: [
                    {
                      type: 'number',
                      min: 1,
                      required: true,

                      message: getI18n(
                        'salesChannelRegistration.index.numberErrorMessage1',
                      ),
                    },
                    {
                      type: 'number',
                      max: 10,
                      required: true,

                      message: getI18n(
                        'salesChannelRegistration.index.numberErrorMessage2',
                      ),
                    },
                  ],
                }}
                prefix={getI18n('salesChannelRegistration.index.atleast')}
                suffix={getI18n('salesChannelRegistration.index.numbers')}
              />
            ) : null;
          }}
        </ShouldUpdateItem>
      </React.Fragment>
      <React.Fragment>
        <Item
          name={['passwordFormat', 'enableMustContainLetters']}
          valuePropName='checked'>
          <OriCheckbox
            onChange={onChange}
            className={css.checkbox}
            disabled={disableEdit}>
            {getI18n('salesChannelRegistration.index.mustcontainsletters')}
          </OriCheckbox>
        </Item>
        <ShouldUpdateItem name='passwordFormat.enableMustContainLetters'>
          {({ getFieldValue }: any) => {
            const enable = getFieldValue([
              'passwordFormat',
              'enableMustContainLetters',
            ]);
            return enable ? (
              <_NumberInput
                //max={10}
                onChange={onChange}
                formProps={{
                  name: ['passwordFormat', 'minNumOfLetters'],
                  rules: [
                    {
                      type: 'number',
                      min: 1,
                      required: true,
                      message: getI18n(
                        'salesChannelRegistration.index.numberErrorMessage1',
                      ),
                    },
                    {
                      type: 'number',
                      max: 10,
                      required: true,
                      message: getI18n(
                        'salesChannelRegistration.index.numberErrorMessage2',
                      ),
                    },
                  ],
                }}
                prefix={getI18n('salesChannelRegistration.index.atleast')}
                suffix={getI18n('general.letters')}
                disabled={disableEdit}
              />
            ) : null;
          }}
        </ShouldUpdateItem>
      </React.Fragment>
      <React.Fragment>
        <Item
          name={['passwordFormat', 'enableMustContainLowerCases']}
          valuePropName='checked'>
          <OriCheckbox
            onChange={onChange}
            className={css.checkbox}
            disabled={disableEdit}>
            {getI18n(
              'salesChannelRegistration.index.mustcontainslowercaseletters',
            )}
          </OriCheckbox>
        </Item>
        <ShouldUpdateItem name='passwordFormat.enableMustContainLowerCases'>
          {({ getFieldValue }: any) => {
            const enable = getFieldValue([
              'passwordFormat',
              'enableMustContainLowerCases',
            ]);
            return enable ? (
              <_NumberInput
                // max={10}
                disabled={disableEdit}
                onChange={onChange}
                formProps={{
                  name: ['passwordFormat', 'minNumOfLowerCases'],
                  rules: [
                    {
                      type: 'number',
                      min: 1,
                      required: true,
                      message: getI18n(
                        'salesChannelRegistration.index.numberErrorMessage1',
                      ),
                    },
                    {
                      type: 'number',
                      max: 10,
                      required: true,

                      message: getI18n(
                        'salesChannelRegistration.index.numberErrorMessage2',
                      ),
                    },
                  ],
                }}
                prefix={getI18n('salesChannelRegistration.index.atleast')}
                suffix={getI18n(
                  'salesChannelRegistration.index.lowercaseletters',
                )}
              />
            ) : null;
          }}
        </ShouldUpdateItem>
      </React.Fragment>
      <React.Fragment>
        <Item
          name={['passwordFormat', 'enableMustContainUpperCases']}
          valuePropName='checked'>
          <OriCheckbox
            onChange={onChange}
            className={css.checkbox}
            disabled={disableEdit}>
            {getI18n(
              'salesChannelRegistration.index.mustcontainsuppercaseletters',
            )}
          </OriCheckbox>
        </Item>
        <ShouldUpdateItem name='passwordFormat.enableMustContainUpperCases'>
          {({ getFieldValue }: any) => {
            const enable = getFieldValue([
              'passwordFormat',
              'enableMustContainUpperCases',
            ]);
            return enable ? (
              <_NumberInput
                //max={10}
                disabled={disableEdit}
                onChange={onChange}
                formProps={{
                  name: ['passwordFormat', 'minNumOfUpperCases'],
                  rules: [
                    {
                      type: 'number',
                      min: 1,
                      required: true,
                      message: getI18n(
                        'salesChannelRegistration.index.numberErrorMessage1',
                      ),
                    },
                    {
                      type: 'number',
                      max: 10,
                      required: true,

                      message: getI18n(
                        'salesChannelRegistration.index.numberErrorMessage2',
                      ),
                    },
                  ],
                }}
                prefix={getI18n('salesChannelRegistration.index.atleast')}
                suffix={getI18n(
                  'salesChannelRegistration.index.uppercaseletters',
                )}
              />
            ) : null;
          }}
        </ShouldUpdateItem>
      </React.Fragment>
      <React.Fragment>
        <Item
          name={['passwordFormat', 'enableMustContainSpecialChars']}
          valuePropName='checked'>
          <OriCheckbox
            onChange={onChange}
            className={css.checkbox}
            disabled={disableEdit}>
            {getI18n(
              'salesChannelRegistration.index.mustcontainsspecialcharacters',
            )}
          </OriCheckbox>
        </Item>
        <ShouldUpdateItem name='passwordFormat.enableMustContainSpecialChars'>
          {({ getFieldValue }: any) => {
            const enable = getFieldValue([
              'passwordFormat',
              'enableMustContainSpecialChars',
            ]);
            return enable ? (
              <_NumberInput
                //max={10}
                disabled={disableEdit}
                onChange={onChange}
                formProps={{
                  name: ['passwordFormat', 'minNumOfSpecialChars'],
                  rules: [
                    {
                      type: 'number',
                      min: 1,
                      required: true,
                      message: getI18n(
                        'salesChannelRegistration.index.numberErrorMessage1',
                      ),
                    },
                    {
                      type: 'number',
                      max: 10,
                      required: true,

                      message: getI18n(
                        'salesChannelRegistration.index.numberErrorMessage2',
                      ),
                    },
                  ],
                }}
                prefix={getI18n('salesChannelRegistration.index.atleast')}
                suffix={getI18n(
                  'salesChannelRegistration.index.specialcharacters',
                )}
              />
            ) : null;
          }}
        </ShouldUpdateItem>
      </React.Fragment>
      <React.Fragment>
        <Item
          name={['passwordFormat', 'enableMinLength']}
          valuePropName='checked'>
          <OriCheckbox
            onChange={onChange}
            className={css.checkbox}
            disabled={disableEdit}>
            {getI18n('salesChannelRegistration.index.minimumlength')}
          </OriCheckbox>
        </Item>
        <ShouldUpdateItem name='passwordFormat.enableMinLength'>
          {({ getFieldValue }: any) => {
            const enable = getFieldValue(['passwordFormat', 'enableMinLength']);
            return enable ? (
              <_NumberInput
                disabled={disableEdit}
                onChange={onChange}
                formProps={{
                  name: ['passwordFormat', 'minLength'],
                  rules: [
                    {
                      type: 'number',
                      min: 1,
                      required: true,
                      message: getI18n(
                        'salesChannelRegistration.index.numberErrorMessage1',
                      ),
                    },
                  ],
                }}
                prefix={getI18n('salesChannelRegistration.index.atleast')}
                suffix={getI18n('salesChannelRegistration.index.characters')}
                max={20}
              />
            ) : null;
          }}
        </ShouldUpdateItem>
      </React.Fragment>
      <React.Fragment>
        <Item
          name={['passwordFormat', 'enableMaxLength']}
          valuePropName='checked'>
          <OriCheckbox
            onChange={onChange}
            className={css.checkbox}
            disabled={disableEdit}>
            {getI18n('salesChannelRegistration.index.maximumlength')}
          </OriCheckbox>
        </Item>
        <ShouldUpdateItem>
          {({ getFieldValue }: any) => {
            const enable = getFieldValue(['passwordFormat', 'enableMaxLength']);

            const minNumOfNumbers = getFieldValue([
              'passwordFormat',
              'enableMustContainNumbers',
            ])
              ? getFieldValue(['passwordFormat', 'minNumOfNumbers']) || 0
              : 0;
            const minNumOfLetters = getFieldValue([
              'passwordFormat',
              'enableMustContainLetters',
            ])
              ? getFieldValue(['passwordFormat', 'minNumOfLetters']) || 0
              : 0;
            const minNumOfLowerCases = getFieldValue([
              'passwordFormat',
              'enableMustContainLowerCases',
            ])
              ? getFieldValue(['passwordFormat', 'minNumOfLowerCases']) || 0
              : 0;
            const minNumOfUpperCases = getFieldValue([
              'passwordFormat',
              'enableMustContainUpperCases',
            ])
              ? getFieldValue(['passwordFormat', 'minNumOfUpperCases']) || 0
              : 0;
            const minNumOfSpecialChars = getFieldValue([
              'passwordFormat',
              'enableMustContainSpecialChars',
            ])
              ? getFieldValue(['passwordFormat', 'minNumOfSpecialChars']) || 0
              : 0;
            const minLength = getFieldValue([
              'passwordFormat',
              'enableMinLength',
            ])
              ? getFieldValue(['passwordFormat', 'minLength']) || 0
              : 0;

            const letters =
              minNumOfLetters > minNumOfLowerCases + minNumOfUpperCases
                ? minNumOfLetters
                : minNumOfLowerCases + minNumOfUpperCases;

            const total = minNumOfNumbers + letters + minNumOfSpecialChars;

            return enable ? (
              <_NumberInput
                disabled={disableEdit}
                onChange={onChange}
                formProps={{
                  name: ['passwordFormat', 'maxLength'],
                  rules: [
                    {
                      validator: async (x, value) => {
                        if (5 >= value) {
                          return Promise.reject(
                            new Error(
                              getI18n(
                                'salesChannelRegistration.index.validatorError1',
                              ),
                            ),
                          );
                        }
                        if (total > value) {
                          return Promise.reject(
                            new Error(
                              getI18n(
                                'salesChannelRegistration.index.validatorError2',
                              ),
                            ),
                          );
                        }
                        if (minLength > value) {
                          return Promise.reject(
                            new Error(
                              getI18n(
                                'salesChannelRegistration.index.validatorError3',
                              ),
                            ),
                          );
                        }
                        if (!value) {
                          return Promise.reject(
                            new Error(
                              getI18n(
                                'salesChannelRegistration.index.validatorError4',
                              ),
                            ),
                          );
                        }
                      },
                      type: 'number',
                      min: 6,
                      required: true,
                      //   message:
                      //     'Maximum length cannot be less than the sum of the minimium amount above and greater than min length',
                    },
                  ],
                }}
                prefix={getI18n('salesChannelRegistration.index.atmost')}
                suffix={getI18n('salesChannelRegistration.index.characters')}
                //max={40}
              />
            ) : null;
          }}
        </ShouldUpdateItem>
      </React.Fragment>
    </SectionWrapper>
  );
};
export default PasswordFormat;
const ShouldUpdateItem = (props) => {
  const { children, name } = props;
  return (
    <Item
      noStyle
      shouldUpdate={(prevValues, curValues) => {
        if (!name) {
          return true;
        }
        const pEnable = !!get(prevValues, name);
        const cEnable = !!get(curValues, name);
        return pEnable !== cEnable;
      }}>
      {children}
    </Item>
  );
};
const _NumberInput = (props) => {
  const { formProps, prefix, suffix, onChange, inputProps, max, disabled } =
    props;

  return (
    <Item className={css.item} {...formProps}>
      <__Number
        whenOnChange={onChange}
        {...(inputProps || {})}
        prefix={prefix}
        suffix={suffix}
        max={max}
        disabled={disabled}
      />
    </Item>
  );
};
const __Number = (props) => {
  const { value, onChange, suffix, prefix, whenOnChange, id, max, disabled } =
    props;

  const [number, setNumber] = React.useState(value || null);
  React.useEffect(() => {
    if (value !== number) {
      setNumber(value);
    }
  }, [value]);
  const triggerChange = (changedValue) => {
    const { _number } = changedValue;
    onChange?.(_number);
  };

  const onNumberChange = (e) => {
    if (whenOnChange) whenOnChange(e);
    setNumber(e);
    triggerChange({
      _number: e,
    });
  };
  return (
    <div className={css.itemContainer} id={id}>
      <div>{prefix}</div>
      <NumberInput
        disabled={disabled}
        className={css.input}
        type='text'
        value={number}
        onChange={onNumberChange}
        size='large'
        min={0}
        max={max}
      />
      <div>{suffix}</div>
    </div>
  );
};
